import { Badge, Theme } from "@120wateraudit/waterworks";
import React from "react";

export const SERVICE_LINE_STATUS_VALUES: Record<string, string> = {
  Abandoned: "Abandoned",
  InService: "In Service",
  OutOfService: "Out Of Service",
  Stubbed: "Stubbed",
};

export const serviceLineStatusOptions = Object.keys(
  SERVICE_LINE_STATUS_VALUES
).map(key => ({
  id: key,
  text: SERVICE_LINE_STATUS_VALUES[key],
  value: key
}))

export const getServiceLineStatusValue = (status?: string): string => {
  return (status && SERVICE_LINE_STATUS_VALUES[status]) ?? "--";
};

interface StatusBadgeProps {
  status: string;
  style?: React.CSSProperties;
}

export const ServiceLineStatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  style,
}) => {
  const statusColor = status === "InService" ? Theme.palette.primary : Theme.palette.warning;
  const statusTextColor = status === "InService" ? Theme.palette.neutral900 : Theme.palette.white;
  const statusLabel = getServiceLineStatusValue(status);
  return (
    <Badge
      style={{
        ...style,
        justifyContent: "center",
        textAlign: "center",
        minWidth: "80px",
        color: statusTextColor,
      }}
      backgroundColor={statusColor}
    >
      {statusLabel}
    </Badge>
  );
};

export default ServiceLineStatusBadge;
